'use client';

import { useEffect } from 'react';

/**
 * Removes the `data-entrance` attribute (server-rendered on <html>) ~1.6s after
 * load, so the CSS hero entrance (animation.css `html[data-entrance]
 * .hero-entrance-*`) plays exactly once per document load and never replays
 * when the hero re-mounts on an SPA navigation back to the homepage.
 *
 * This used to ALSO run a body-opacity FOUC gate (hide <body> on first visit,
 * reveal at ~500ms). That was removed: it hid the whole page until 500ms AND
 * fought the always-on CSS entrance — the page painted, the effect hid it
 * (flash), then revealed it mid-animation (flash again), tanking FCP/LCP. The
 * CSS entrance now provides the first-paint polish on its own and the rest of
 * the page simply paints immediately.
 */
const PageLoader = () => {
  useEffect(() => {
    const t = window.setTimeout(() => {
      document.documentElement.removeAttribute('data-entrance');
    }, 1600);
    return () => window.clearTimeout(t);
  }, []);

  return null;
};

export default PageLoader;
